import { graphql } from 'gatsby';
import {
  StyledComparisonCard,
  StyledHeader,
  StyledIcon,
  StyledCTAs,
  StyledHeadline,
  StyledSubheadline,
  StyledBody,
} from './ComparisonCard.styles';
import Link from '@/components/Link/Link';
import { RichTextElement } from '@kontent-ai/gatsby-components';

const ComparisonCard = ({
  system: { codename },
  elements: { icon, headline, subheadline, body, primary_cta, secondary_cta },
}: Queries.COMPARISON_CARDFragment) => {
  const hasPrimaryCTA = primary_cta?.value;
  const hasSecondaryCTA = secondary_cta?.value;
  const hasBothCTAs = Boolean(hasPrimaryCTA && hasSecondaryCTA);

  return (
    <StyledComparisonCard data-codename={codename}>
      <div>
        <StyledHeader>
          <StyledIcon {...icon.value} />
          <div>
            <StyledHeadline>{headline.value}</StyledHeadline>
            <StyledSubheadline>{subheadline.value}</StyledSubheadline>
          </div>
        </StyledHeader>
        <StyledBody>
          <RichTextElement value={body.value} />
        </StyledBody>
      </div>
      <StyledCTAs hasBothCTAs={hasBothCTAs}>
        {primary_cta?.value && <Link {...primary_cta.value} variant="primary_dark" />}
        {secondary_cta?.value && <Link {...secondary_cta.value} variant="secondary_dark" />}
      </StyledCTAs>
    </StyledComparisonCard>
  );
};

export default ComparisonCard;

export const fragment = graphql`
  fragment COMPARISON_CARD on kontent_item_comparison_card {
    system {
      id
      codename
    }
    elements {
      icon {
        value {
          url
        }
      }
      headline {
        value
      }
      subheadline {
        value
      }
      body {
        value
      }
      primary_cta {
        value {
          __typename
          ... on kontent_item {
            system {
              id
            }
          }
          ...LINK
        }
      }
      secondary_cta {
        value {
          __typename
          ... on kontent_item {
            system {
              id
            }
          }
          ...LINK
        }
      }
    }
  }
`;
